import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { USER_INIT } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { UserInitActionTypes } from './types';
import userApi from 'src/utils/api/userApi';

export const loadUserInit =
  (): ThunkAction<Promise<void>, State, null, UserInitActionTypes> =>
  async (dispatch: any) => {
    dispatch({ type: USER_INIT + REQUEST });
    try {
      const payload = await userApi.loadUserInit();
      dispatch({ type: USER_INIT + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: USER_INIT + FAILURE, error });
    }
  };

export const allListSurveyIdle = () => ({ type: USER_INIT + IDLE });
